import { render } from "./loginpage.vue?vue&type=template&id=6e2775ae"
import script from "./loginpage.vue?vue&type=script&lang=js"
export * from "./loginpage.vue?vue&type=script&lang=js"

import "./loginpage.vue?vue&type=style&index=0&id=6e2775ae&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__